module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/254.18302dfe.png";